import { formatEncoded } from "@e308/ux";
import { formatMicro, type Micro, microFromString } from "../exact-numbers.js";
import { type TroopComposition, UNIT_IDS } from "../logistics-types.js";
import type { SeatObservation } from "../types.js";
import type { AppNode } from "./view-nodes.js";
import { text } from "./view-nodes.js";

export function armySummary(o: SeatObservation): AppNode {
  const total = (groups: readonly TroopComposition[]) =>
    formatEncoded(
      formatMicro(
        groups.reduce(
          (sum, group) => sum + UNIT_IDS.reduce((n, unit) => n + microFromString(group[unit]), 0n),
          0n,
        ) as Micro,
      ),
      { significantDigits: 4, plainDecimalPlaces: 2 },
    );
  return {
    kind: "section",
    id: "army-summary",
    style: { className: "kf-army-summary" },
    children: [
      text(
        "reserve-army",
        `Reserves · Guards ${formatEncoded(o.self.units["guard-robot"])} · Raiders ${formatEncoded(o.self.units["raider-robot"])} · Guns ${formatEncoded(o.self.units["siege-gun"])}`,
      ),
      text(
        "moving-army",
        `Gathered ${total(Object.values(o.self.logistics.reinforcement?.gathered ?? {}))} · Traveling ${total(o.self.logistics.transits.map((transit) => transit.units))}`,
      ),
    ],
  };
}
